import * as client from "_graphql-types";
import * as types from "./types";

import { filterSortPage } from "../DataProvider";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.IconEnumSortEnum>
) {
  const { pagination, sort } = params;

  const {
    iconEnumList: { items: data, total },
  } = await sdk.getListIconEnum(
    filterSortPage({
      sort,
      pagination,
    })
  );
  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { iconEnum: data } = await sdk.getOneIconEnum({
    id,
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { iconEnumMany: data } = await sdk.getManyIconEnum({
    ids,
  });

  return {
    data,
  };
}

/*********************************************************************/
export const iconEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
  ttl: types.defaultEnumTtl,
});
